/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryUnloadEndpointRequest
 */
export interface TapeLibraryUnloadEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryUnloadEndpointRequest
     */
    barcode: string;
}

export function TapeLibraryUnloadEndpointRequestFromJSON(json: any): TapeLibraryUnloadEndpointRequest {
    return TapeLibraryUnloadEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryUnloadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryUnloadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TapeLibraryUnloadEndpointRequestToJSON(value?: TapeLibraryUnloadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
    };
}


